export const uk = {
    seconds: 'сек'
};
